import React, { useState } from 'react';
import clsx from 'clsx';

import type { VFC } from 'react';

import styles from './_styles/HeadNav.module.scss';

type Props = {
  path: string,
}

const HeadNav: VFC<Props> = ({ path }) => {
  const [open, setOpen] = useState(false);

  const handleOpen = () => {
    setOpen(!open);
  };

  const [sub, setSub] = useState(0);

  const handleSub = (e) => {
    const target = e.currentTarget;
    const number = Number(target.dataset.number);
    if (number === sub) {
      setSub(0);
    } else {
      setSub(number);
    }
  }

  return (
    <>
      <button className={clsx(styles.btn, open && styles.btnActive)} onClick={handleOpen}>
        <div className={styles.btnBox}>
          <span className={clsx(styles.bar, open && styles.barActive)} />
          <span className={clsx(styles.bar, open && styles.barActive)} />
          <span className={clsx(styles.bar, open && styles.barActive)} />
        </div>
      </button>
      <nav className={clsx(styles.nav, open && styles.navActive )}>
        <ul className={styles.menu}>
          <li className={clsx(styles.item, styles.itemWith, sub === 1 && styles.itemWithActive)}>
            <button className={clsx(styles.link, sub === 1 && styles.linkActive)} data-number="1" onClick={handleSub}>TOP</button>
            <div className={clsx(styles.subWrap, sub === 1 && styles.subWrapActive)}>
              <ul className={styles.sub}>
                <li className={styles.subItem}>
                  <a className={styles.subLink} href={`${path}./.`}>TOP</a>
                </li>
                <li>
                  <a className={styles.subLink} href={`${path}newslist.html`}>重要なお知らせ一覧</a>
                </li>
              </ul>
            </div>
          </li>
          <li className={styles.item}>
            <a className={styles.link} href={`${path}attractive.html`}>私達の魅力</a>
          </li>
          {/* <li className={styles.item}>
            <a className={styles.link} href={`${path}works/`}>事業紹介</a>
          </li> */}
          <li className={clsx(styles.item, styles.itemWith, sub === 2 && styles.itemWithActive)}>
            <button className={clsx(styles.link, sub === 2 && styles.linkActive)} data-number="2" onClick={handleSub}>事業紹介</button>
            <div className={clsx(styles.subWrap, sub === 2 && styles.subWrapActive)}>
              <ul className={styles.sub}>
                <li className={styles.subItem}>
                  <a className={styles.subLink} href={`${path}works/`}>事業紹介</a>
                </li>
                <li className={styles.subItem}>
                  <a className={styles.subLink} href={`${path}works/service.html`}>オペレーション部門</a>
                </li>
                <li className={styles.subItem}>
                  <a className={styles.subLink} href={`${path}works/general.html`}>総務部門</a>
                </li>
              </ul>
            </div>
          </li>
          <li className={styles.item}>
            <a className={styles.link} href={`${path}corporate.html`}>会社案内</a>
          </li>
          <li className={clsx(styles.item, styles.itemWith, sub === 3 && styles.itemWithActive)}>
            <button className={clsx(styles.link, sub === 3 && styles.linkActive)} data-number="3" onClick={handleSub}>各種取り組み</button>
            <div className={clsx(styles.subWrap, sub === 3 && styles.subWrapActive)}>
              <ul className={styles.sub}>
                <li className={styles.subItem}>
                  <a className={styles.subLink} href={`${path}efforts/`}>各種取り組みについて</a>
                </li>
                <li className={styles.subItem}>
                  <a className={styles.subLink} href={`${path}efforts/sdgs.html`}>SDGsの取り組み</a>
                </li>
              </ul>
            </div>
          </li>
          {/* <li className={styles.item}>
            <a className={styles.link} href={`${path}recruit/`}>採用情報</a>
          </li> */}
          <li className={clsx(styles.item, styles.itemWith, sub === 4 && styles.itemWithActive)}>
            <button className={clsx(styles.link, sub === 4 && styles.linkActive)} data-number="4" onClick={handleSub}>採用情報</button>
            <div className={clsx(styles.subWrap, sub === 4 && styles.subWrapActive)}>
              <ul className={styles.sub}>
                <li className={styles.subItem}>
                  <a className={styles.subLink} href={`${path}recruit/`}>採用情報</a>
                </li>
                <li className={styles.subItem}>
                  <a className={styles.subLink} href={`${path}recruit/#voice`}>先輩の声</a>
                </li>
                <li className={styles.subItem}>
                  <a className={styles.subLink} href={`${path}recruit/new.html`}>新卒募集</a>
                </li>
                <li className={styles.subItem}>
                  <a className={styles.subLink} href={`${path}recruit/career.html`}>中途募集</a>
                </li>
              </ul>
            </div>
          </li>
          <li className={styles.contact}>
            <a className={styles.contactLink} href={`${path}contact.html`}>
              <span className={styles.contactIcon}>
                <img src={`${path}images/contact-mail.svg`} alt="メール" width="100" height="80" />
              </span>
              <span className={styles.contactText}>お問い合わせ</span>
            </a>
          </li>
          <li className={clsx(styles.item, styles.itemSp)}>
            <a className={styles.link} href={`${path}privacy.html`}>個⼈情報保護⽅針</a>
          </li>
          <li className={clsx(styles.item, styles.itemSp)}>
            <a className={styles.link} href={`${path}sitemap.html`}>サイトマップ</a>
          </li>
        </ul>
      </nav>
    </>
  );
};

export default HeadNav;